import { useCompanyCompetitors } from '../../../../shared/hooks/useCompanyCompetitors';
import type { TreeSelection } from '../types/filters';
import { getNumericIdFromNestedId } from '../utils/get-numeric-id-from-nested-id';

/**
 * The first selection's competitors, shaped as tree selections for the shortcut
 * panel above the picker. A thin adapter over `useCompanyCompetitors` — the
 * request itself is shared so both this and the company tooltip resolve to one
 * cache entry rather than fetching the same company twice.
 */
export const useCompetitorSuggestions = ({
  enabled,
  firstSelection,
}: {
  enabled: boolean;
  firstSelection?: TreeSelection;
}): { suggestions: TreeSelection[]; isLoading: boolean } => {
  const entityId =
    firstSelection?.levelId === 'company'
      ? getNumericIdFromNestedId(firstSelection.id)
      : null;

  const { competitors, isLoading } = useCompanyCompetitors(entityId, {
    enabled,
  });

  // A disabled source offers nothing, even where the query was enabled earlier
  // and its result is still held.
  const suggestions: TreeSelection[] = enabled
    ? competitors.map((competitor) => ({
        id: String(competitor.rcid),
        name: competitor.name,
        levelId: 'company',
      }))
    : [];

  return { suggestions, isLoading };
};
